import { useEffect, useRef, useState } from 'react';
import { ChevronDown, LogOut, Menu, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Avatar from '../components/Avatar';
import SessionIdleBadge from '../components/SessionIdleBadge';
import StoreStatusControl from '../components/StoreStatusControl';
import packageJson from '../../package.json';
import GlobalSearch from './GlobalSearch';
import styles from './Topbar.module.css';

const GREETINGS = ['Good morning', 'Good afternoon', 'Good evening'];

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return GREETINGS[0];
  if (h < 17) return GREETINGS[1];
  return GREETINGS[2];
}

export default function Topbar({ onMenuClick }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const firstName = (user?.name || 'Staff').split(' ')[0];

  return (
    <header className={styles.bar}>
      <button
        type="button"
        className={styles.menuToggle}
        onClick={onMenuClick}
        aria-label="Open navigation"
      >
        <Menu size={20} />
      </button>

      <div className={styles.greetingBlock}>
        <h1 className={styles.greeting}>
          <span className={styles.greetingFull}>{greeting()}, {firstName} 👋</span>
          <span className={styles.greetingShort}>{firstName}</span>
        </h1>
        <p className={styles.date}>
          {new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' })}
        </p>
      </div>

      <GlobalSearch />

      <div className={styles.right}>
        <SessionIdleBadge />
        <span className={styles.version} title="App version">v{packageJson.version}</span>
        <StoreStatusControl />

        <div className={styles.menuAnchor} ref={menuRef}>
          <button className={styles.profileBtn} onClick={() => setMenuOpen((v) => !v)}>
            <Avatar name={user?.name || 'Store Staff'} size={32} />
            <ChevronDown size={14} className={styles.profileChevron} />
          </button>
          {menuOpen && (
            <div className={styles.menu}>
              <div className={styles.menuHeader}>
                <p className={styles.menuName}>{user?.name}</p>
                <p className={styles.menuEmail}>{user?.email}</p>
              </div>
              <button
                className={styles.menuItem}
                onClick={() => { setMenuOpen(false); navigate('/profile'); }}
              >
                <User size={15} /> View profile
              </button>
              <button
                className={`${styles.menuItem} ${styles.menuDanger}`}
                onClick={() => { logout(); navigate('/login'); }}
              >
                <LogOut size={15} /> Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
